export default __webpack_public_path__ + "static/media/vox-img-legacy-001.b1f1aaa3.jpg";